import React from "react";

import Charts from "../../../Charts";

const getDaysBetween = (start, end) => {
  let arr = [];

  for (
    let dt = new Date(start);
    dt <= new Date(end);
    dt.setDate(dt.getDate() + 1)
  ) {
    arr.push(new Date(dt));
  }

  return arr;
};

const getMonthsBetween = (start, end) => {
  const fromDate = new Date(start);
  const toDate = new Date(end);

  const fromYear = fromDate.getUTCFullYear();
  const fromMonth = fromDate.getUTCMonth();
  const toYear = toDate.getUTCFullYear();
  const toMonth = toDate.getUTCMonth();
  const months = [];
  for (let year = fromYear; year <= toYear; year++) {
    let month = year === fromYear ? fromMonth : 0;
    const monthLimit = year === toYear ? toMonth : 11;
    for (; month <= monthLimit; month++) {
      months.push({
        month: (month + 1).toString().padStart(2, "0"),
        year: year.toString()
      });
    }
  }

  return months;
};

const ChartWhoAccess = props => {
  let days = [];
  if (props.period === "day") {
    days = getDaysBetween(props.start, props.end).map(day => {
      const date = `${day.getUTCFullYear()}-${(day.getUTCMonth() + 1)
        .toString()
        .padStart(2, "0")}-${day.getUTCDate().toString().padStart(2, "0")}`;
      const label = `${day.getUTCDate().toString().padStart(2, "0")}/${(
        day.getUTCMonth() + 1
      )
        .toString()
        .padStart(2, "0")}/${day.getUTCFullYear()}`;

      return {
        date,
        label,
        value: props.data[date] || 0
      };
    });
  } else {
    days = getMonthsBetween(props.start, props.end).map(month => {
      const date = `${month.year}-${month.month}`;
      const label = `${month.month}/${month.year}`;

      return {
        date,
        label,
        value: props.data[date] || 0
      };
    });
  }

  return (
    <div>
      <Charts
        key={`${props.period}-${props.start}-${props.end}`}
        legendY=""
        legendX=""
        type="line"
        title=""
        data={{
          labels: days.map(item => item.label),
          datasets: [
            {
              data: days.map(item => item.value),
              // backgroundColor: [
              //   "rgba(255, 99, 132, 0.2)",
              //   "rgba(54, 162, 235, 0.2)",
              //   "rgba(255, 206, 86, 0.2)",
              //   "rgba(75, 192, 192, 0.2)",
              //   "rgba(153, 102, 255, 0.2)",
              //   "rgba(255, 159, 64, 0.2)",
              // ],
              // borderColor: [
              //   "rgba(255, 99, 132, 1)",
              //   "rgba(54, 162, 235, 1)",
              //   "rgba(255, 206, 86, 1)",
              //   "rgba(75, 192, 192, 1)",
              //   "rgba(153, 102, 255, 1)",
              //   "rgba(255, 159, 64, 1)",
              // ],
              borderWidth: 1,
              backgroundColor: "rgba(2, 73, 112, 0.2)",
              borderColor: "rgba(2, 73, 112, 1)"
            }
          ]
        }}
      />
    </div>
  );
};

export default ChartWhoAccess;
